<template>
  <div class="video-container relative w-full h-0 pt-0" style="padding-bottom: 60%">
    <iframe :src="urlComplete" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
  name: "Youtube",
  data() {
    return {};
  },
  props: {
    url: {
      default: null
    }
  },
  components: {},
  methods: {},
  computed: {
    urlComplete() {
      let youtubeCode = this.url ? this.url.split("?v=")[1] : "";
      return "https://www.youtube.com/embed/" + youtubeCode;
    }
  },
  created() {}
};
</script>

<style scoped>
.video-container iframe,
.video-container object,
.video-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>